export default __webpack_public_path__ + "media/images/portfolio/gallery-08-390x230-c51ea5fcdc948cad4f1b5670fd437ce9.jpg";